import { type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { useMediaQuery } from '~/hooks/useMediaQuery';
import { breakpoints } from '~/styles/media.css';

import { Button } from '../Button/Button';
import { Drawer } from '../Drawer/Drawer';
import { TableFilterTags } from './TableFilterTags';
import { useTableContext } from './TableRoot.context';

export type Props = {
  children: ReactNode;
};

export const TableFilters = ({ children }: Props) => {
  const { state } = useTableContext();

  const { t } = useTranslation(['common']);

  const isMobile = useMediaQuery(breakpoints.medium);

  if (!isMobile) return <>{children}</>;

  return (
    <Drawer.Root>
      <Drawer.Trigger
        render={
          <Button emphasis="secondary" icon="Filter">
            {t('common:datatable.showFilters')}
            {state.columnFilters.length > 0 ? ` (${state.columnFilters.length})` : ''}
          </Button>
        }
      />

      <Drawer.Popup>
        <Drawer.Header title={t('common:datatable.filters')} />

        <Drawer.Content>
          {children}

          <TableFilterTags />
        </Drawer.Content>

        <Drawer.Actions>
          <Drawer.Close render={<Button>{t('common:datatable.showResults')}</Button>} />
        </Drawer.Actions>
      </Drawer.Popup>
    </Drawer.Root>
  );
};
